/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：996
 */

var r = require(/* 863 */"../../../1459/863")
module.exports = function (e, t) {
  for (var /* [auto-meaningful-name] */e$length = e.length; e$length--;) {
    if (r(e[e$length][0], t)) {
      return e$length
    }
  }
  return -1
}
